import { Image, Text, View } from '@react-pdf/renderer'

import {
  formatDateTime,
  formatDateTimeInTimeZone,
} from '@/utils/formatDateTime'

import { styles } from '../styles/styles'
import { ReportHeaderIProps } from '../types/types'

export const Header = ({ branding, incident }: ReportHeaderIProps) => {
  const headerTitle = [branding.orgName.toUpperCase(), 'INCIDENT REPORT']
    .filter(Boolean)
    .join(' - ')
  const timeZone = incident?.facility?.timeZone
  const incidentDate =
    formatDateTimeInTimeZone(incident?.createdAt, timeZone, 'MM-dd-yyyy') ||
    formatDateTime(incident?.createdAt, 'MM-dd-yyyy')
  const incidentTime =
    formatDateTimeInTimeZone(incident?.createdAt, timeZone, 'HH:mm') ||
    formatDateTime(incident?.createdAt, 'HH:mm')

  return (
    <>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>{headerTitle}</Text>
        {branding.logoUrl && (
          <Image src={branding.logoUrl} style={styles.headerLogo} />
        )}
      </View>

      <Text style={styles.incidentTitle}>
        {incident?.displayId} {incident?.name}
      </Text>

      <View style={styles.metadataRow}>
        <View>
          <Text style={styles.detailLabel}>Date</Text>
          <Text style={styles.detailLabel}>Facility</Text>
          <Text style={styles.detailLabel}>Location</Text>
          <Text style={styles.detailLabel}>Time</Text>
          <Text style={styles.detailLabel}>Facility Time Zone</Text>
        </View>
        <View>
          <Text style={styles.detailValue}>{incidentDate}</Text>
          <Text style={styles.detailValue}>
            {incident?.facility?.name ?? ''}
          </Text>
          <Text style={styles.detailValue}>
            {incident?.address?.toString()}
          </Text>
          <Text style={styles.detailValue}>{incidentTime}</Text>
          <Text style={styles.detailValue}>{timeZone ?? ''}</Text>
        </View>
      </View>

      <View style={styles.sectionDivider} />
    </>
  )
}
